import React from 'react';
import { TileLayout, TileLayoutItem, TilePosition } from '@progress/kendo-react-layout';
import { AboutPageEditor } from './AboutPageEditor';
import { GenericSettingsMenu } from '../GenericSettingsMenu';
import {
  useGlobalizationContext,
  useTranslation,
  useGetUserPermissions,
  useGetUiAdminConfigWritePermissions
} from '@cs-cms/state-management';
import { ABOUT_PAGE_SETTINGS_KEY, CpsSettingMenuItem } from '@cs-cms/types';
import { ItAdminCenterMenuItemType, IT_ADMIN_CENTER_MENU_ITEM_TYPE } from '../../types/ItAdminCenterMenuItemType';

const postitions: TilePosition[] = [
  {
    col: 1,
    colSpan: 1
  },
  {
    col: 2,
    colSpan: 1
  }
];

export const ItAdminCenterManagement: React.FC = () => {
  const [selectedMenuItem, setSelectedMenuItem] = React.useState<ItAdminCenterMenuItemType>(
    IT_ADMIN_CENTER_MENU_ITEM_TYPE.ABOUT_PAGE_EDITOR
  );
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const { data: permissions } = useGetUserPermissions();
  const { data: writePermissions } = useGetUiAdminConfigWritePermissions([ABOUT_PAGE_SETTINGS_KEY]);

  const menu: CpsSettingMenuItem[] =
    permissions?.itAdminSection && writePermissions?.[ABOUT_PAGE_SETTINGS_KEY] === true
      ? [
          {
            text: translate('custom.settings.adminCenter.configurations.title'),
            value: IT_ADMIN_CENTER_MENU_ITEM_TYPE.ABOUT_PAGE_EDITOR
          }
        ]
      : [];

  const getActiveBody = (menuItem: ItAdminCenterMenuItemType | undefined) => {
    if (menuItem === IT_ADMIN_CENTER_MENU_ITEM_TYPE.ABOUT_PAGE_EDITOR) {
      return <AboutPageEditor />;
    }

    return undefined;
  };

  const tiles: TileLayoutItem[] = [
    {
      body: (
        <GenericSettingsMenu<CpsSettingMenuItem, ItAdminCenterMenuItemType>
          menu={menu}
          value={selectedMenuItem}
          onSelectedMenuItemChanged={(value: ItAdminCenterMenuItemType) => setSelectedMenuItem(value)}
        />
      ),
      className: 'helpCenterTileLayoutItem',
      reorderable: false,
      resizable: false
    },
    {
      body: getActiveBody(selectedMenuItem),
      className: 'helpCenterTileLayoutItem',
      reorderable: false,
      resizable: false
    }
  ];

  return (
    <div className="helpCenter">
      <TileLayout columns={2} positions={postitions} items={tiles} />
    </div>
  );
};
